import React, { useContext } from "react";
import ADD_ORDER_MUTATION from "../queries/ADD_ORDER_MUTATION";
import { EventTypes } from '../../store/actions';
import { Button } from "react-bootstrap";
import { AppContext } from "../../store";
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { removeTypename } from "../../utils";

type NewOrderButtonProps = {
    children: React.ReactNode,
    size: "sm" | "lg",
    variant: string,
    disabled?: boolean,
};

const NewOrderButton = ({children, size, variant, disabled}:NewOrderButtonProps) => {
    const navigate = useNavigate();
    const { state, dispatch } = useContext(AppContext);
    const currentEvent = state.eventInfo.currentEvent;
    const stakeholders = currentEvent?.stakeholders || [];
    
    const getNewOrderInput = () => {
        const eventId = currentEvent?.eventId;
        const chapterId = currentEvent?.chapterId;
        if (!eventId) return;
        const me = {
            name: state?.accountInfo?.name,
            email: state?.accountInfo?.username,
            constituentId: state?.orgInfo?.constituent_id || '',
            role: 'V',
        }
        return {
            description: `Order to support ${eventId} for ${chapterId} from ${me.email}`,
            state: 'new',
            eventId: eventId,
            chapterId: chapterId,
            items: [],
            stakeholders: [...stakeholders, me],
        };
    };
    const [addOrder, { loading: newOrderLoading }] = useMutation(ADD_ORDER_MUTATION, {
        onCompleted: (data: any) => {
            dispatch({
                type: EventTypes.SetOrders,
                payload: { ...state.eventInfo, orders: [...state.eventInfo.orders, data.addOrder,], currentOrder: data.addOrder },
            });
            navigate(`/page/ordering?eventId=${data.addOrder.eventId}`);
        }
    });

    const startNewOrder = () => {
        addOrder({
            variables: {
                orderData: removeTypename({
                    ...getNewOrderInput()
                }),
            },
        });
    };
    return <Button size={size} variant={variant} onClick={startNewOrder} disabled={newOrderLoading || disabled}>{children}</Button>;
}
export default NewOrderButton;